'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgUpload(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M5.979 4.043a.484.484 0 00.484-.471v-1.46l-.04-.807.282.31.74.8a.444.444 0 00.323.141c.256 0 .444-.175.444-.417a.406.406 0 00-.148-.316L6.328.16C6.208.041 6.107 0 5.978 0c-.12 0-.221.04-.342.161L3.894 1.823a.422.422 0 00-.142.316c0 .242.182.417.437.417a.46.46 0 00.33-.141l.74-.8.282-.31-.04.807v1.46c0 .255.222.47.478.47zM2.965 12H9c1.15 0 1.715-.565 1.715-1.695V5.26c0-1.13-.565-1.695-1.715-1.695H6.59v3.794c0 .33-.276.598-.612.598a.606.606 0 01-.606-.598V3.565H2.965c-1.143 0-1.715.565-1.715 1.695v5.045c0 1.13.572 1.695 1.715 1.695z", id: "Upload__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Upload__svg__a" })))));
}

module.exports = SvgUpload;
//# sourceMappingURL=Upload.js.map
